<template>
  <footer class="bg-gray-900 text-gray-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div class="text-white text-xl font-bold mb-4">Linguidia</div>
          <p class="text-gray-400">
            Votre partenaire pour la réussite aux examens de langue. Apprenez intelligemment,
            progressez rapidement.
          </p>
          <div class="flex space-x-4 mt-6">
            <a href="https://www.facebook.com/share/1CX3B5uq2X/" target="_blank" class="text-gray-400 hover:text-white"
              ><span class="sr-only">Facebook</span
              ><svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.323-1.325z"
                /></svg
            ></a>
          </div>
        </div>
        <div>
          <div class="text-white text-xl font-bold mb-4">Navigation</div>
          <ul class="space-y-3">
            <li><a href="/" class="hover:text-white transition-colors">Accueil</a></li>
            <li>
              <a href="/dashboard/exercises" class="hover:text-white transition-colors">Examens</a>
            </li>
            <li><a href="/packages" class="hover:text-white transition-colors">Packages</a></li>
            <li>
              <a href="/login" class="hover:text-white transition-colors">Inscription/Connexion</a>
            </li>
          </ul>
        </div>
        <div>
          <div class="text-white text-xl font-bold mb-4">Légal</div>
          <ul class="space-y-3">
            <li>
              <a href="#" class="hover:text-white transition-colors">Conditions d'utilisation</a>
            </li>
            <li>
              <a href="#" class="hover:text-white transition-colors"
                >Politique de confidentialité</a
              >
            </li>
          </ul>
        </div>
        <div>
          <div class="text-white text-xl font-bold mb-4">Restez informé</div>
          <p class="text-gray-400 mb-4">Recevez nos conseils et offres exclusives.</p>
          <form class="flex">
            <input
              type="email"
              placeholder="Votre email"
              class="w-full px-4 py-2 rounded-l-lg bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-primary-500"
            />
            <button
              title="S'inscrire à la newsletter"
              class="bg-primary-600 px-4 py-2 rounded-r-lg hover:bg-primary-700 transition-colors"
            >
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="mx-auto px-4 bg-white">
      <div class="flex container flex-col md:flex-row items-center justify-between py-6">
        <p class="text-sm text-gray-500 text-center md:text-left mb-4 md:mb-0">
          Copyright © {{ currentYear }}
          <a
            href="#"
            class="font-semibold text-primary-500 hover:text-primary-700 transition-colors"
            >New Start Agency</a
          >. Tous droits réservés.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<script>
export default {
  name: 'app-footer',
}
</script>

<style scoped></style>
